import config from '../nyConfig'
const ApiExport = {
    "字典列表": new config({ url: '/export/listDic', showSuccessMessage: false, useToken: true }),
    "修改专家": new config({ url: '/export/editExport', showSuccessMessage: true, useToken: true }),
    "专家列表": new config({ url: '/export/listExport', showSuccessMessage: false, useToken: true }),
    "专家详情": new config({ url: '/export/infoExport', showSuccessMessage: false, useToken: true }),
    "冻结解冻": new config({ url: '/export/changeStatus', showSuccessMessage: true, useToken: true }),
    "删除专家": new config({ url: '/export/delExport', showSuccessMessage: true, useToken: true }),
    "专家字典列表": new config({ url: '/export/listExportDic', showSuccessMessage: false, useToken: true }),
    "预约列表": new config({ url: '/export/listSubscribe', showSuccessMessage: false, useToken: true }),
    "导出当前预约列表": new config({ url: '/export/exportSubscribePage', showSuccessMessage: false, useToken: true }),
    "导出全部预约列表": new config({ url: '/export/exportSubscribeAll', showSuccessMessage: false, useToken: true }),
    "咨询主题": new config({ url: '/export/listDataDic', showSuccessMessage: false, useToken: true }),
    "保存排序": new config({ url: '/export/saveSort', showSuccessMessage: true, useToken: true }),
    "专家数据上移": new config({ url: '/export/moveUp', showSuccessMessage: true, useToken: true }),
    "专家数据下移": new config({ url: '/export/moveDown', showSuccessMessage: true, useToken: true }),
    "专家数据置顶": new config({ url: '/export/moveTop', showSuccessMessage: true, useToken: true }),
    "专家取消置顶": new config({ url: '/export/cancelTop', showSuccessMessage: true, useToken: true }),
}

export default ApiExport